import { render, staticRenderFns } from "./siteRanking.vue?vue&type=template&id=a1839554&scoped=true&"
import script from "./siteRanking.vue?vue&type=script&lang=js&"
export * from "./siteRanking.vue?vue&type=script&lang=js&"
import style0 from "./siteRanking.vue?vue&type=style&index=0&id=a1839554&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1839554",
  null
  
)

export default component.exports